export const PROJECT_NAME = 'Saas QR';
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://api.pos.grooops.com.my'; // Production
// export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://grooops-api.dev-rmaict.com' // Local Development
export const WEBSITE_URL = 'https://admin.pos.grooops.com.my'; // Production
// export const WEBSITE_URL = 'https://grooops.dev-rmaict.com'; // Local Development
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const MAP_API_KEY = 'AIzaSyD_Z5jZ7Rid2Z823rl-hnMCVjk_kyG1Njo';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';

export const VAPID_KEY =
  'BC3irh-rWahZL6GEzZ39m7pM43dkVM7Leh4V35bGfrXk_Mo8nN-V2VeFKxxvGGIjWjiCFBP41L3H6Xj9XG6Utv8';

export const LAT = 47.4143302506288;
export const LNG = 8.532059477976883;

export const API_KEY = 'AIzaSyABJjE0NCIyy2Rccg92OJYqQWbf9gYdpkI';
export const AUTH_DOMAIN = 'pos-android-76bdb.firebaseapp.com';
export const PROJECT_ID = 'pos-android-76bdb';
export const STORAGE_BUCKET = 'pos-android-76bdb.firebasestorage.app';
export const MESSAGING_SENDER_ID = '274749991854';
export const APP_ID = '1:274749991854:web:b84c41f5367926edce763f';
export const MEASUREMENT_ID = 'G-9D88TQDN4H';

export const RECAPTCHASITEKEY = '6Lf6jQIrAAAAAIBPSqB2aLUnprd14bXWo-lC7fam';

export const DEMO_SELLER = 334; // seller_id
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0'; // seller_id
export const DEMO_SHOP = 599; // seller_id
export const DEMO_DELIVERYMAN = 375; // deliveryman_id
export const DEMO_MANEGER = 114; // deliveryman_id
export const DEMO_MODERATOR = 297; // deliveryman_id
export const DEMO_ADMIN = 107; // deliveryman_id

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
